<template>
    <Dropdown placement="bottom-start" trigger="custom" :visible="dropdownIsVisible" @onClickoutside="toggleDropdown">
        <hox-dropdown-button
            :is-active="dropdownIsVisible"
            :is-disabled="deliverables.length === 0 || isDisabled"
            :is-loading="isSettingDeliverableStatus"
            button-type="primary"
            data-testid="library__production-status-select"
            @click="toggleDropdown"
        >
            <slot>Production status</slot>
        </hox-dropdown-button>
        <template #list>
            <qa-status-dropdown-items @statusSelected="setDeliverableStatus" />
        </template>
    </Dropdown>
</template>

<script>
import QaStatusDropdownItems from "@/components/Campaign/QaStatusDropdownItems.vue";
import HoxDropdownButton from "@/components/common/DropdownButton.vue";
import { BannerQaStatusLabel } from "@/enums/filters";
import { setDeliverablesGlobalStatus } from "@/services/Qa";
import { DeliverableLibraryAction } from "@/store/modules/deliverableLibrary";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";
import { mapStores } from "pinia";

export default {
    components: {
        HoxDropdownButton,
        QaStatusDropdownItems
    },
    props: {
        deliverables: {
            required: true,
            type: Array
        },
        isDisabled: {
            type: Boolean
        },
        itemToChangeNumber: {
            required: false,
            type: Number
        }
    },

    emits: ["statusHasBeenSet"],

    data() {
        return {
            dropdownIsVisible: false,
            isSettingDeliverableStatus: false
        };
    },
    computed: {
        ...mapStores(useCreativeLibraryFiltersStore),
        campaignId() {
            return this.$route.params.campaignId;
        }
    },
    methods: {
        toggleDropdown() {
            this.dropdownIsVisible = !this.dropdownIsVisible;
        },
        async setDeliverableStatus(status) {
            this.toggleDropdown();
            this.isSettingDeliverableStatus = true;
            const deliverablesCount = this.itemToChangeNumber || this.deliverables.length;
            try {
                const deliverables = await setDeliverablesGlobalStatus(
                    this.campaignId,
                    this.deliverables,
                    status,
                    this.creativeLibraryFiltersStore.getComputedLibraryFilters
                );
                this.$store.dispatch(DeliverableLibraryAction.SetDeliverableStatusByIdHash, deliverables);
                if (deliverablesCount === 1) {
                    this.$snackbar.success(`The deliverable is now "${BannerQaStatusLabel[status]}"`);
                } else {
                    this.$snackbar.success(
                        `${deliverablesCount} deliverables are now "${BannerQaStatusLabel[status]}"`
                    );
                }
                this.$emit("statusHasBeenSet");
            } catch {
                this.$snackbar.error(
                    "There was an unexpected error and the deliverable status was unable to be set. Please try again in a few moments."
                );
            }
            this.isSettingDeliverableStatus = false;
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
